import React from 'react';
import { getAllLockerStatus, subscribeToLockerUpdates } from '../data/firebaseService';
import './LockerStatus.css';

const LockerStatus = ({ location, onLockerClick }) => {
  const [lockerData, setLockerData] = React.useState({});
  const [selectedLocker, setSelectedLocker] = React.useState(null);

  React.useEffect(() => {
    const initializeData = async () => {
      try {
        const status = await getAllLockerStatus();
        setLockerData(status[location] || {});
      } catch (error) {
        console.error('Error loading locker status:', error);
      }
    };

    initializeData();
    
    // Set up real-time listener for locker updates
    const unsubscribe = subscribeToLockerUpdates((lockers) => {
      setLockerData(lockers[location] || {});
    });
    
    return () => unsubscribe();
  }, [location]);

  const handleLockerClick = (lockerId) => {
    setSelectedLocker(lockerId);
    if (onLockerClick) {
      onLockerClick(lockerId, lockerData[lockerId]);
    }
  };

  const locationNames = {
    'rajinder_nagar': 'Rajinder Nagar',
    'patel_nagar': 'Patel Nagar'
  };

  return (
    <div className="locker-status">
      <div className="locker-header">
        <h2>🔒 Locker Status - {locationNames[location]}</h2>
        <p className="status-legend">
          🟢 Available | 🔴 Occupied | 🔒 PIN Protected
        </p>
      </div>

      <div className="locker-grid">
        {Object.entries(lockerData).map(([lockerId, locker]) => (
          <div
            key={lockerId}
            className={`locker-item ${locker.status} ${selectedLocker === lockerId ? 'selected' : ''}`}
            onClick={() => handleLockerClick(lockerId)}
          >
            <div className="locker-number">
              {lockerId.toUpperCase()}
            </div>
            
            <div className="locker-status-indicator">
              {locker.status === 'empty' ? (
                <span className="status-empty">🟢 Available</span>
              ) : (
                <span className="status-full">🔴 Occupied</span>
              )}
            </div>

            {locker.status === 'full' && (
              <div className="locker-details">
                <div className="pin-display">
                  PIN: <strong>{locker.pin}</strong>
                </div>
                {locker.customerData && (
                  <div className="customer-info">
                    <div>📱 {locker.customerData.phoneNumber}</div>
                    <div>👕 {locker.customerData.numberOfClothes} items</div>
                    <div>🛠️ {locker.customerData.serviceType}</div>
                  </div>
                )}
              </div>
            )}

            {locker.status === 'empty' && (
              <div className="locker-empty">
                <span>Click to assign</span>
              </div>
            )}
          </div>
        ))}
      </div>

      {selectedLocker && lockerData[selectedLocker] && (
        <div className="selected-locker-info">
          <h3>Selected: {selectedLocker.toUpperCase()}</h3>
          <div className="info-details">
            <p><strong>Status:</strong> {lockerData[selectedLocker].status}</p>
            {lockerData[selectedLocker].pin && (
              <p><strong>PIN:</strong> {lockerData[selectedLocker].pin}</p>
            )}
            {lockerData[selectedLocker].customerData && (
              <>
                <p><strong>Phone:</strong> {lockerData[selectedLocker].customerData.phoneNumber}</p>
                <p><strong>Items:</strong> {lockerData[selectedLocker].customerData.numberOfClothes}</p>
                <p><strong>Service:</strong> {lockerData[selectedLocker].customerData.serviceType}</p>
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default LockerStatus; 